import React, {Component} from 'react';
import "./TemporalCategoriesFilter.css"
import "./commonAnalysisStyle.css"

import $ from "jquery";

import "ion-rangeslider"
import "ion-rangeslider/css/ion.rangeSlider.css"
import "ion-rangeslider/css/normalize.css"
import "./ion.rangeSlider.skinFlat.css"

const Highcharts = require('highcharts');


//require('highcharts/modules/exporting')(Highcharts);

class TemporalCategoriesFilter extends Component {
    chart = undefined

    constructor(props) {
        super(props);


        let widget = this


        this.state = {
            fromDate: 1901,
            toDate: 1954,
            incarichiRappresentanzaTag: false,
            incarichiGovernoTag: false,
            saggistaGiornalistaTag: false,
            stampaTag: false,
            periodiciTag:false,
            quotidianiTag: false,
            libriPrefazioniTag:false,
            discorsiPubliciTag:false,
            interventiIstituzionaliTag:false,
            documentiTag:false,
            documentiUfficialiTag: false,
            interventiDiPartitoTag: false,
            interventiInSediIstituzionaliTag: false,
            filteredFiles: []
        };


        if (this.props.fromTo.from !== undefined && this.props.fromTo.to !== undefined){
            this.state.fromDate = this.props.fromTo.from
            this.state.toDate = this.props.fromTo.to
        }

        if(this.props.tags.tags !== undefined){

            if (this.props.tags.tags.includes("quotidiani")){
                this.state.quotidianiTag = true
            }

            if (this.props.tags.tags.includes("documenti")){
                this.state.documentiTag = true
            }

            if (this.props.tags.tags.includes("libri")){
                this.state.libriPrefazioniTag = true
            }

            if (this.props.tags.tags.includes("periodici")){
                this.state.periodiciTag = true
            }

            if (this.props.tags.tags.includes("discorsi")){
                this.state.discorsiPubliciTag = true
            }

            if (this.props.tags.tags.includes("istituzionali")){
                this.state.interventiIstituzionaliTag = true
            }

            if (this.props.tags.tags.includes("partito")){
                this.state.interventiDiPartitoTag = true
            }


            let parameters = {
                corpusID: "deg",
                sortmethod: "dataInsertion",
                sortdirection: "ASC",
                tags: JSON.stringify({
                    quotidiani: this.state.quotidianiTag,
                    periodici: this.state.periodiciTag,
                    libriPrefazioni: this.state.libriPrefazioniTag,
                    discorsiPublici: this.state.discorsiPubliciTag,
                    interventiIstituzionali: this.state.interventiIstituzionaliTag,
                    interventiDiPartito: this.state.interventiDiPartitoTag,
                    documenti: this.state.documentiTag

                })
            }

            $.ajax({
                type: "POST",
                url: window.apiAlcideUrlPrefix + "getFilteredDocsByTags",
                data: parameters,
                async: false,
                dataType: "json",
                success: function (data) {
                    widget.state.filteredFiles = data
                }
            });

        }




    }

    onFromToChange() {
        this.props.callbackParent(this.state); // we notify our parent
    }

    componentDidMount() {

        var Myself = this;



        let slider = $('#timeSlider').ionRangeSlider({
            type: "double",
            min: 1901,
            max: 1954,
            from: Myself.state.fromDate,
            to: Myself.state.toDate,
            drag_interval: true,
            prettify_enabled: false,
            grid: false,
            force_edges: true,
            hide_min_max: true,
            onFinish: function (data) {
                Myself.setState({fromDate: data.from, toDate: data.to});
                Myself.onFromToChange()
            }
        });



        this.chart = Highcharts.chart(document.getElementById('chart'), {
                credits: {
                    enabled: false
                },
                chart: {
                    backgroundColor: 'transparent',
                    color: "#fff",
                    height: 150
                },

                title: {
                    text: ''
                },
                yAxis: {
                    labels: {enabled: false},
                    gridLineColor: "transparent",
                    lineColor: "transparent",
                    title: null
                },
                xAxis: {
                    categories: [],
                    lineColor: "transparent",
                    gridLineColor: "transparent",
                    labels: {enabled: false},
                    tickColor: "transparent"

                },
                plotOptions: {
                    column: {
                        borderRadius: 3,
                        color: "#ffffff",
                    },
                    series: {
                        cursor: 'pointer',
                        allowPointSelect: true,
                        point: {
                            events: {
                                select: function () {
                                    Myself.props.callbackParentSelectedYear(this.category);
                                }

                            }
                        }
                    }


                },

                series:
                    [{
                        name: 'Documenti',
                        type: 'column',
                        colorByPoint: false,
                        data: [],
                        showInLegend: false,
                        label: {enabled: false}
                    }]
            }
        )
       // console.log(this.state.filteredFiles);

        let ff = this.state.filteredFiles
        let newState = {fromDate: slider.data("from"), toDate: slider.data("to"),filteredFiles :ff};
        this.setState(newState)
        this.props.callbackParent(newState);

        
        
        let chart = this.chart
        document.getElementById("analises_column").addEventListener("scroll", (ev) => {
            // console.log(ev);
            let scrollVal = document.getElementById("analises_column").scrollTop;
            if (scrollVal > 200) {
                $('#TemporalWidget_Container').addClass("fixedFloatingWidget");
                document.getElementById("spacer").style.display = "block"
                chart.setSize(chart.width, 100, false);
                chart.redraw()
            } else if (scrollVal < 50) {
                $('#TemporalWidget_Container').removeClass("fixedFloatingWidget");
                document.getElementById("spacer").style.display = "none"
                chart.setSize(chart.width, 150, false);
                chart.redraw()

            }
        });


        if (this.state.quotidianiTag){
            $("#quotidiani_selector").addClass("filterStringEnabled")
        }

        if (this.state.documentiTag){
            $("#documenti_selector").addClass("filterStringEnabled")
        }

        if (this.state.libriPrefazioniTag){
            $("#libri_selector").addClass("filterStringEnabled")
        }

        if (this.state.periodiciTag){
            $("#periodici_selector").addClass("filterStringEnabled")
        }

        if (this.state.discorsiPubliciTag){
            $("#discorsi_selector").addClass("filterStringEnabled")
        }

        if (this.state.interventiIstituzionaliTag){
            $( "#interventi_selector").addClass("filterStringEnabled")
        }

        if (this.state.interventiDiPartitoTag ){
            $("#partito_selector").addClass("filterStringEnabled")
        }











    }

    updateChart(items) {
        let Myself = this;
        // console.log(items);
        let countByYear = {}

        ///// to be refine ///
        let min = 1901;
        let max = 1954;

        items.forEach((doc) => {
            let year = doc.props.date.substr(0, 4)
            max = Math.max(parseInt(year), max)
            min = Math.min(parseInt(year), min)
            if (countByYear.hasOwnProperty(doc.props.date.substr(0, 4))) {
                countByYear[year]++;
            } else {
                countByYear[year] = 1
            }


        })


        let categories = []
        let serie = []
        for (let i = min; i <= max; i++) {
            categories.push(i)
            if (countByYear.hasOwnProperty(i)) {
                serie.push(countByYear[i])
            } else {
                serie.push(0)
            }
        }
        ////
        this.chart.xAxis[0].setCategories(categories)
        this.chart.series[0].setData(serie);
        let selectedPoints = this.chart.getSelectedPoints();
        selectedPoints.forEach((p) => {
            p.select(false, false);
        })

        //console.log(selectedPoints);

        let chart = this.chart
        window.onresize = function (event) {
            document.getElementById('TemporalWidget_Container').style.width = document.getElementById('TemporalWidget_Container').parentElement.offsetWidth + 'px'
            chart.redraw()
        };
        window.dispatchEvent(new Event('resize'));
        Myself.props.callbackParentSelectedYear(undefined);


    }

    handleOptionChange = (changeEvent) => {
        let clickedTag = changeEvent.currentTarget.getAttribute("val")
        let clickedElement = changeEvent.currentTarget
        let widget = this

        this.setState({
            [clickedTag]: !this.state[clickedTag]
        }, () => {
            if (this.state[clickedTag]) {
                $(clickedElement).addClass("filterStringEnabled")
            } else {
                $(clickedElement).removeClass("filterStringEnabled")
            }

            let parameters = {
                corpusID: "deg",
                sortmethod: "dataInsertion",
                sortdirection: "ASC",
                tags: JSON.stringify({
                    quotidiani: this.state.quotidianiTag,
                    periodici: this.state.periodiciTag,
                    libriPrefazioni: this.state.libriPrefazioniTag,
                    discorsiPublici: this.state.discorsiPubliciTag,
                    interventiIstituzionali: this.state.interventiIstituzionaliTag,
                    interventiDiPartito: this.state.interventiDiPartitoTag,
                    documenti: this.state.documentiTag

                })
            }

            $.ajax({
                type: "POST",
                url: window.apiAlcideUrlPrefix + "getFilteredDocsByTags",
                data: parameters,
                async: false,
                dataType: "json",
                success: function (data) {
                   // console.log(data)

                    widget.setState({filteredFiles: data}, () => {
                        widget.props.callbackParent(widget.state);
                    })

                    // data.forEach((i) => {
                    //     elements.push(<Item  key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
                    // })
                }
            });

        });
    }

    render() {
        return (
            <div id="TemporalWidget_Container" className="TemporalCatWidgetStyle commonAnalysisFeatures">
                <center>
                    <div className="analisysTitle">Tempo e contesto</div>
                    <div id="chart"></div>
                    <div id="timeSliderContainer">
                        <div id="timeSlider"></div>
                    </div>
                </center>
                <div className="filterBox">
                    <span className="filterString" onClick={this.handleOptionChange} val="quotidianiTag" id="quotidiani_selector">Quotidiani</span> / <span className="filterString" onClick={this.handleOptionChange} val="periodiciTag" id="periodici_selector">Periodici</span> / <span className="filterString" onClick={this.handleOptionChange} val="libriPrefazioniTag" id="libri_selector">Libri/Prefazioni</span> / <span className="filterString" onClick={this.handleOptionChange} val="documentiTag" id="documenti_selector">Documenti</span> / <span className="filterString" onClick={this.handleOptionChange} val="discorsiPubliciTag" id="discorsi_selector">Discorsi pubblici</span> / <span className="filterString" onClick={this.handleOptionChange} val="interventiIstituzionaliTag" id="interventi_selector">Interventi istituzionali</span> / <span className="filterString" onClick={this.handleOptionChange} val="interventiDiPartitoTag" id="partito_selector">Interventi di partito</span>
                    {/*<span className="filterString" onClick={this.handleOptionChange} val="stampaTag">Stampa</span> / <span className="filterString" onClick={this.handleOptionChange} val="documentiUfficialiTag">Documenti Ufficiali</span> / <span className="filterString" onClick={this.handleOptionChange} val="interventiDiPartitoTag">Interventi di partito</span> / <span className="filterString" onClick={this.handleOptionChange} val="interventiInSediIstituzionaliTag">Interventi in sedi istituzionali</span>*/}
                </div>
                {/*<div className="radioList">*/}
                {/*<input className="magic-checkbox" type="checkbox" name="checkBoxTagFilter" id="checkBoxTagFilter1" value="incarichiRappresentanzaTag" checked={this.state.incarichiRappresentanzaTag} onChange={this.handleOptionChange}/>*/}
                {/*<label htmlFor="checkBoxTagFilter1">*/}
                {/*Incarichi di rappresentanza*/}
                {/*</label>*/}

                {/*<input className="magic-checkbox" type="checkbox" name="checkBoxTagFilter" id="checkBoxTagFilter2" value="incarichiGovernoTag" checked={this.state.incarichiGovernoTag} onChange={this.handleOptionChange}/>*/}
                {/*<label htmlFor="checkBoxTagFilter2">*/}
                {/*Incarichi di governo*/}
                {/*</label>*/}

                {/*<input className="magic-checkbox" type="checkbox" name="checkBoxTagFilter" id="checkBoxTagFilter3" value="saggistaGiornalistaTag" checked={this.state.saggistaGiornalistaTag} onChange={this.handleOptionChange}/>*/}
                {/*<label htmlFor="checkBoxTagFilter3">*/}
                {/*Saggista/Giornalista*/}
                {/*</label>*/}
                {/*</div>*/}

            </div>
        );
    }
}

export default TemporalCategoriesFilter;


// WEBPACK FOOTER //
// ./src/components/TemporalCategoriesFilter.jsx